import { SupportedLanguages } from '../../../../voice-response-command/vrc-audio-metadata/supported-languages';
import { speechDigitsProducedByMachine } from '../../../helper/was-answered-by-machine/speech-digits-produced-by-machine/speech-digits-produced-by-machine';
import { getKeyPressFromStr } from '../get-key-press-from-str/get-key-press-from-str';
import { isPhoneticMatch } from '../is-phonetic-match/is-phonetic-match';
import { normalizeSpeechResult } from '../normalize-speech-result';

import { DoesMatchPhraseInput } from './interfaces';

export const doesMatchPhrase = (params: DoesMatchPhraseInput): boolean => {
  if (params.detectedSpeech === undefined) {
    return false;
  }

  if (speechDigitsProducedByMachine(params.detectedSpeech, params.detectedDigits)) {
    return false;
  }

  const detectedWords = normalizeSpeechResult(params.detectedSpeech, params.language).split(' ');

  const acceptedPhrases = (params.acceptedPhrases ?? []).map((phrase) =>
    normalizeSpeechResult(phrase, params.language).split(' '),
  );

  if (acceptedPhrases.length === 0) {
    return false;
  }

  const exactlyMatches = acceptedPhrases.some((phraseWords) =>
    detectedWords.some((_, i) => phraseWords.every((word, j) => detectedWords[i + j] === word)),
  );

  if (exactlyMatches) {
    return true;
  }

  if (params.language !== SupportedLanguages.en) {
    return false;
  }

  const normalizedDetectedWords = detectedWords.map((word) => getKeyPressFromStr(word) ?? word);
  const normalizedAcceptedPhrases = acceptedPhrases.map((phraseWords) =>
    phraseWords.map((word) => getKeyPressFromStr(word) ?? word),
  );

  return normalizedAcceptedPhrases.some((phraseWords) => {
    const phraseJoined = phraseWords.join('');
    return normalizedDetectedWords.some((_, i) => {
      const maxWindowSize = Math.min(phraseWords.length + 1, normalizedDetectedWords.length - i);
      for (let windowSize = 1; windowSize <= maxWindowSize; windowSize += 1) {
        const windowJoined = normalizedDetectedWords.slice(i, i + windowSize).join('');
        if (isPhoneticMatch(windowJoined, phraseJoined)) {
          return true;
        }
      }
      return false;
    });
  });
};
